import {BasePlatformHandler} from "@shared/base/base-platform-handler.service";
import {HttpClient} from "@angular/common/http";
import {CommandService} from "@core/services/command.service";
import {Router} from "@angular/router";
import {DialogService} from "@shared/services/dialog-service";
import {FuseSplashScreenService} from "@barebone-fuse-services/splash-screen.service";
import {Store} from "@ngrx/store";
import {IQueryState} from "@shared/store/reducers/query.reducer";
import {SnackBarService} from "@core/services/snack-bar.service";
import {FileManagementService} from "@core/services/file-management.service";
import {PlatformQueryService} from "@core/services/platform-query.service";
import {DataTracingService} from "@features/data-tracing/services/data-tracing.service";
import {ParticleCacheService} from "@core/services/particle-cache.service";
import {FileStoreCommonService} from "@features/file-manager/services/file-store-common.service";
import {ItpDesktopUtilityService} from "@core/services/itpdesktopservices/itp-desktop-utility.service";
import {FileManagerService} from "@features/file-manager/services/file-manager.service";
import {ShareItemService} from "@shared/services/share-item.service";
import {VirtualGridSelectionService} from "@core/services/virtual-grid-selection.service";
import {FlowChartDataService} from "@features/data-survey/services/flow-chart-data.service";
import {Injectable} from "@angular/core";
import {PlatformCommand} from "@shared/commands/command-base";
import {Api} from "@shared/constants/common-field.constants";

@Injectable({
  providedIn: 'root'
})
export class PlatformToolAutomatePublicationHandler extends BasePlatformHandler{
  constructor(
    public httpClient: HttpClient,
    public commandService: CommandService,
    public router: Router,
    public dialogService: DialogService,
    public fuseSplashScreenService: FuseSplashScreenService,
    public queryState: Store<IQueryState>,
    public snackBarService: SnackBarService,
    public fileManagementService: FileManagementService,
    public platformQueryService: PlatformQueryService,
    public dataTracingService: DataTracingService,
    public particleCacheService: ParticleCacheService,
    public fileStoreCommonService: FileStoreCommonService,
    public itpDesktopUtilityService: ItpDesktopUtilityService,
    public fileManagerService: FileManagerService,
    public shareItemService: ShareItemService,
    public virtualGridSelectionService: VirtualGridSelectionService,
    public flowChartDataService: FlowChartDataService
  ) {
    super(httpClient, commandService, router, dialogService, fuseSplashScreenService,
      queryState, snackBarService, fileManagementService, platformQueryService, dataTracingService,
      particleCacheService, fileStoreCommonService, itpDesktopUtilityService, fileManagerService, shareItemService, virtualGridSelectionService, flowChartDataService);
  }
  valueChanged(event: any): void {
    super.valueChanged(event);
    if (event.item.type === 'ChangeReportTracker') {
      if (event.fieldDefinition.key === 'AutoId') {
        this.router.navigateByUrl(`${this.router.url}/${event.item.cells[event.fieldDefinition.key].value}`);
      }
    }
    if (event.fieldDefinition.key === 'AutoId') {
      this.router.navigateByUrl(`${this.router.url}/${event.item.cells[event.fieldDefinition.key].value}`);
    }
    /*switch (event.action.id) {
      case 'Edit':
        this.edit(event);
        break;
    }*/
  }

  private edit(event: any) {
    const minWidth = '800px';
    const maxWidth = '800px';
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth, this.selectedTabModel.tabData['SourceType']).subscribe(state => {
      const updateCommand = new PlatformCommand('UpdateCrPublicationDataCommand', Api.XatBotApi);
      updateCommand.fieldValues['ItemId'] = event?.item?.id;
      updateCommand.fieldValues['SourceType'] = this.selectedTabModel.tabData['SourceType'];
      updateCommand.fieldValues['FieldKey'] = event?.fieldDefinition?.key;
      updateCommand.fieldValues[event?.fieldDefinition?.key] = event?.item?.cells[event?.fieldDefinition?.key]?.value;
      this.executeCommand(updateCommand);
    })
  }
}
